<template>
  <section class="cashiers-dashboard-wrapper">
    <b-card no-body>
      <b-tabs
        v-model="activeTab"
        card
      >
        <!-- Pending Tab -->
        <b-tab :title="$t('cashiers.pending-title')">
          <div>
            <b-row>
              <!-- <b-col md="3" cols="12">
                <b-form-group
                  :label="$t('common.from-date')"
                  label-for="pending-from-date"
                >
                  <datepicker
                    id="pending-from-date"
                    v-model="pendingFromDate"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3" cols="12">
                <b-form-group
                  :label="$t('common.to-date')"
                  label-for="pending-to-date"
                >
                  <datepicker
                    id="pending-to-date"
                    v-model="pendingToDate"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col> -->

              <b-col
                md="3"
                cols="12"
              >
                <b-form-group
                  :label="$t('common.user')"
                  label-for="pending-user-filter"
                >
                  <b-form-input
                    id="pending-user-filter"
                    v-model.trim="pendingUserFilter"
                    :placeholder="$t('common.search')"
                    @keyup.enter="applyPendingUserFilter"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                cols="12"
              >
                <b-form-group
                  :label="$t('common.invoice-number')"
                  label-for="pending-invoice-number-filter"
                >
                  <b-form-input
                    id="pending-invoice-number-filter"
                    v-model.trim="pendingInvoiceNumberFilter"
                    :placeholder="$t('common.invoice-number')"
                    @keyup.enter="fetchPendingCashiers()"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <b-button
                  class="mt-50"
                  variant="primary"
                  @click="fetchPendingCashiers()"
                >
                  {{ $t("common.search") }}
                  <feather-icon
                    icon="SearchIcon"
                    class="ml-1"
                    size="16"
                  />
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <b-table
                  v-if="!pendingLoading"
                  :items="filteredPendingCashiers"
                  responsive
                  :fields="pendingTableColumns"
                  primary-key="cashierId"
                  class="position-relative"
                  show-empty
                  :empty-text="$t('cashiers.no-cashiers-pending')"
                >
                  <template #cell(cashierId)="data">
                    <span class="font-weight-bold">{{
                      data.item.cashierId
                    }}</span>
                  </template>
                  <template #cell(cashierName)="data">
                    <span>{{ data.item.cashierName }}</span>
                  </template>
                  <template #cell(cashierEmail)="data">
                    <span class="text-nowrap">{{
                      data.item.cashierEmail
                    }}</span>
                  </template>
                  <template #cell(pendingInvoicesCount)="data">
                    <b-badge variant="warning">
                      {{ data.item.pendingInvoicesCount }}
                    </b-badge>
                  </template>
                  <template #cell(actions)="data">
                    <div class="text-nowrap">
                      <b-button
                        size="sm"
                        pill
                        variant="primary"
                        class="mb-75"
                        @click="viewPendingInvoices(data.item.cashierId)"
                      >
                        {{ $t("cashiers.view-pending") }}
                        <feather-icon
                          icon="EyeIcon"
                          class="ml-1"
                          size="14"
                        />
                      </b-button>
                    </div>
                  </template>
                </b-table>
                <template v-if="pendingLoading">
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner label="Loading..." />
                    </div>
                  </div>
                </template>
              </b-col>
            </b-row>
          </div>
          <div
            v-if="pendingPagination.total > 0"
            class="mx-2 mb-2"
          >
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted mr-2">
                  {{ $t("common.showing") }}
                  {{
                    (pendingPagination.page - 1) * pendingPagination.pageSize +
                      1
                  }}
                  {{ $t("common.to") }}
                  {{
                    Math.min(
                      pendingPagination.page * pendingPagination.pageSize,
                      pendingPagination.total,
                    )
                  }}
                  {{ $t("common.of") || "of" }} {{ pendingPagination.total }}
                </span>
                <b-form-select
                  v-model="pendingPagination.pageSize"
                  :options="pageSizeOptions"
                  size="sm"
                  style="width: auto; min-width: 80px"
                  class="ml-2"
                  @change="onPendingPageSizeChange"
                />
              </b-col>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="pendingPagination.page"
                  :total-rows="pendingPagination.total"
                  :per-page="pendingPagination.pageSize"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @change="onPendingPageChange"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>

        <!-- History Tab -->
        <b-tab :title="$t('cashiers.history-title')">
          <div>
            <b-row>
              <b-col
                md="2"
                cols="12"
              >
                <b-form-group
                  label="من تاريخ الكشف"
                  label-for="history-from-date"
                >
                  <datepicker
                    id="history-from-date"
                    v-model="historyFromDate"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                cols="12"
              >
                <b-form-group
                  label="الى تاريخ الكشف"
                  label-for="history-to-date"
                >
                  <datepicker
                    id="history-to-date"
                    v-model="historyToDate"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                cols="12"
              >
                <b-form-group
                  :label="$t('common.invoice-number')"
                  label-for="history-invoice-number-filter"
                >
                  <b-form-input
                    id="history-invoice-number-filter"
                    v-model.trim="historyInvoiceNumberFilter"
                    :placeholder="$t('common.invoice-number')"
                    @keyup.enter="fetchHistoryCashiers()"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <b-button
                  class="mt-50"
                  variant="primary"
                  @click="fetchHistoryCashiers()"
                >
                  {{ $t("common.search") }}
                  <feather-icon
                    icon="SearchIcon"
                    class="ml-1"
                    size="16"
                  />
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <b-table
                  v-if="!historyLoading"
                  :items="historyCashiers"
                  responsive
                  :fields="historyTableColumns"
                  primary-key="cashierId"
                  class="position-relative"
                  show-empty
                  :empty-text="$t('cashiers.no-cashiers')"
                >
                  <template #cell(cashierName)="data">
                    <span>{{ data.item.cashierName }}</span>
                  </template>
                  <template #cell(cashierEmail)="data">
                    <span class="text-nowrap">{{
                      data.item.cashierEmail
                    }}</span>
                  </template>
                  <template #cell(totalInvoicesCount)="data">
                    <b-badge variant="info">{{
                      data.item.totalInvoicesCount || 0
                    }}</b-badge>
                  </template>
                  <template #cell(totalInvoicesAmount)="data">
                    <span class="text-nowrap font-weight-bolder">
                      {{ findTotalInvoicesAmount(data.item) }}
                    </span>
                  </template>
                  <template #cell(actions)="data">
                    <div class="text-nowrap">
                      <b-button
                        size="sm"
                        pill
                        variant="primary"
                        class="mb-75"
                        @click="viewHistory(data.item.cashierId)"
                      >
                        {{ $t("cashiers.view-history") }}
                        <feather-icon
                          icon="EyeIcon"
                          class="ml-1"
                          size="14"
                        />
                      </b-button>
                    </div>
                  </template>
                </b-table>
                <template v-if="historyLoading">
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner label="Loading..." />
                    </div>
                  </div>
                </template>
              </b-col>
            </b-row>
          </div>
          <div
            v-if="historyPagination.total > 0"
            class="mx-2 mb-2"
          >
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted mr-2">
                  {{ $t("common.showing") }}
                  {{
                    (historyPagination.page - 1) * historyPagination.pageSize +
                      1
                  }}
                  {{ $t("common.to") }}
                  {{
                    Math.min(
                      historyPagination.page * historyPagination.pageSize,
                      historyPagination.total,
                    )
                  }}
                  {{ $t("common.of") || "of" }} {{ historyPagination.total }}
                </span>
                <b-form-select
                  v-model="historyPagination.pageSize"
                  :options="pageSizeOptions"
                  size="sm"
                  style="width: auto; min-width: 80px"
                  class="ml-2"
                  @change="onHistoryPageSizeChange"
                />
              </b-col>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="historyPagination.page"
                  :total-rows="historyPagination.total"
                  :per-page="historyPagination.pageSize"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @change="onHistoryPageChange"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BButton,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BSpinner,
  BBadge,
  BTabs,
  BTab,
} from 'bootstrap-vue'
import Datepicker from 'vuejs-datepicker'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'CashiersDashboard',
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BSpinner,
    BBadge,
    BTabs,
    BTab,
    Datepicker,
  },
  data() {
    return {
      activeTab: 0,
      // Pending tab data
      pendingFromDate: null,
      pendingToDate: null,
      pendingUserFilter: '',
      pendingInvoiceNumberFilter: '',
      pendingLoading: false,
      pendingCashiers: [],
      pendingPagination: {
        page: 1,
        pageSize: 15,
        total: 0,
      },
      // History tab data
      historyFromDate: null,
      historyToDate: null,
      historyInvoiceNumberFilter: '',
      historyLoading: false,
      historyCashiers: [],
      historyPagination: {
        page: 1,
        pageSize: 15,
        total: 0,
      },
      // Shared
      pageSizeOptions: [
        { value: 10, text: '10' },
        { value: 15, text: '15' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
      pendingTableColumns: [
        { key: 'cashierName', label: this.$t('cashiers.name'), sortable: true },
        {
          key: 'cashierEmail',
          label: this.$t('common.email') || 'Email',
          sortable: false,
        },
        {
          key: 'pendingInvoicesCount',
          label: this.$t('cashiers.pending-count'),
          sortable: true,
        },
        { key: 'actions', label: this.$t('common.actions') },
      ],
      historyTableColumns: [
        { key: 'cashierName', label: this.$t('cashiers.name'), sortable: true },
        {
          key: 'cashierEmail',
          label: this.$t('common.email') || 'Email',
          sortable: false,
        },
        {
          key: 'totalInvoicesCount',
          label: this.$t('common.total-invoices') || 'Total Invoices',
          sortable: true,
        },
        {
          key: 'totalInvoicesAmount',
          label: this.$t('cashiers.total-amount') || 'Total Amount',
          sortable: true,
        },
        { key: 'actions', label: this.$t('common.actions') },
      ],
    }
  },
  computed: {
    filteredPendingCashiers() {
      if (!this.pendingUserFilter && !this.pendingInvoiceNumberFilter) {
        return this.pendingCashiers
      }
      const userQ = this.pendingUserFilter
        ? this.pendingUserFilter.toLowerCase()
        : ''
      const invoiceQ = this.pendingInvoiceNumberFilter
        ? this.pendingInvoiceNumberFilter.toLowerCase()
        : ''
      return (this.pendingCashiers || []).filter(c => {
        const matchesUser = !userQ
          || (c.cashierName && c.cashierName.toLowerCase().includes(userQ))
          || (c.cashierEmail && c.cashierEmail.toLowerCase().includes(userQ))
          || (c.cashierId && String(c.cashierId).toLowerCase().includes(userQ))
        // Note: invoice number filter would need to be applied server-side
        // as cashier objects don't contain invoice numbers
        return matchesUser
      })
    },
  },
  watch: {
    'historyPagination.page': function () {
      this.fetchHistoryCashiers()
    },
    activeTab(newTab) {
      // Load data when switching to a tab
      if (newTab === 0 && this.pendingCashiers.length === 0) {
        this.fetchPendingCashiers()
      } else if (newTab === 1 && this.historyCashiers.length === 0) {
        this.fetchHistoryCashiers()
      }
    },
    $route(to) {
      // Switch tab based on route
      if (to.name === 'cashiers-history') {
        this.activeTab = 1
        if (this.historyCashiers.length === 0) {
          this.fetchHistoryCashiers()
        }
      } else if (to.name === 'cashiers-pending') {
        this.activeTab = 0
        if (this.pendingCashiers.length === 0) {
          this.fetchPendingCashiers()
        }
      }
    },
  },
  mounted() {
    // Set active tab based on route
    if (this.$route.name === 'cashiers-history') {
      this.activeTab = 1
      this.fetchHistoryCashiers()
    } else {
      this.activeTab = 0
      this.fetchPendingCashiers()
    }
  },
  methods: {
    // Pending tab methods
    applyPendingUserFilter() {
      // Just triggers re-compute; server filter can be added later if backend supports it
    },
    async fetchPendingCashiers() {
      this.pendingLoading = true
      try {
        let url = `invoices/cashiers-with-pending?page=${this.pendingPagination.page}&take=${this.pendingPagination.pageSize}&sort=-id`
        if (this.pendingFromDate) {
          const fromDateFormatted = this.formatDateWithTime(
            this.pendingFromDate,
            false,
          )
          url += `&from=${encodeURIComponent(fromDateFormatted)}`
        }
        if (this.pendingToDate) {
          const toDateFormatted = this.formatDateWithTime(
            this.pendingToDate,
            true,
          )
          url += `&to=${encodeURIComponent(toDateFormatted)}`
        }
        if (
          this.pendingInvoiceNumberFilter
          && this.pendingInvoiceNumberFilter.trim()
        ) {
          url += `&invoice_no=${encodeURIComponent(
            this.pendingInvoiceNumberFilter.trim(),
          )}`
        }
        await this.getList(url)
        if (this.all_data) {
          // Support both array and object responses
          if (Array.isArray(this.all_data.data)) {
            this.pendingCashiers = this.all_data.data.map(
              this.normalizePendingRow,
            )
          } else if (Array.isArray(this.all_data)) {
            this.pendingCashiers = this.all_data.map(this.normalizePendingRow)
          }
          // Laravel-style pagination keys
          if (
            this.all_data.current_page
            || this.all_data.per_page
            || this.all_data.total
          ) {
            this.pendingPagination.page = this.all_data.current_page || 1
            this.pendingPagination.pageSize = this.all_data.per_page || this.pendingPagination.pageSize
            this.pendingPagination.total = this.all_data.total || 0
          } else if (this.all_data.meta) {
            this.pendingPagination.page = this.all_data.meta.page || 1
            this.pendingPagination.pageSize = this.all_data.meta.take
              || this.all_data.meta.pageSize
              || this.pendingPagination.pageSize
            this.pendingPagination.total = this.all_data.meta.total || 0
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('common.error'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text:
              error.response?.data?.message
              || this.$t('cashiers.failed-fetch-cashiers'),
          },
        })
      } finally {
        this.pendingLoading = false
      }
    },
    normalizePendingRow(raw) {
      // Map backend keys → UI keys
      return {
        cashierId: raw.cashier_id || raw.cashierId || raw.id,
        cashierName: raw.cashier_name || raw.name,
        cashierEmail: raw.cashier_email || raw.email || '-',
        pendingInvoicesCount:
          raw.pending_invoices_count || raw.pendingCount || 0,
      }
    },
    viewPendingInvoices(cashierId) {
      this.$router.push({
        name: 'cashier-pending',
        params: { cashierId },
      })
    },
    onPendingPageChange(page) {
      this.fetchPendingCashiers()
    },
    onPendingPageSizeChange() {
      this.pendingPagination.page = 1
      this.fetchPendingCashiers()
    },
    // History tab methods
    async fetchHistoryCashiers() {
      this.historyLoading = true
      try {
        let url = `invoices/all-cashiers?page=${this.historyPagination.page}&take=${this.historyPagination.pageSize}&sort=-id`
        if (this.historyFromDate) {
          const fromDateFormatted = this.formatDateWithTime(
            this.historyFromDate,
            false,
          )
          url += `&paid_from=${encodeURIComponent(fromDateFormatted)}`
        }
        if (this.historyToDate) {
          const toDateFormatted = this.formatDateWithTime(
            this.historyToDate,
            true,
          )
          url += `&paid_to=${encodeURIComponent(toDateFormatted)}`
        }
        if (
          this.historyInvoiceNumberFilter
          && this.historyInvoiceNumberFilter.trim()
        ) {
          url += `&invoice_no=${encodeURIComponent(
            this.historyInvoiceNumberFilter.trim(),
          )}`
        }
        await this.getList(url)
        if (this.all_data) {
          // Normalize data array
          const rows = Array.isArray(this.all_data.data)
            ? this.all_data.data
            : Array.isArray(this.all_data)
              ? this.all_data
              : []
          this.historyCashiers = rows.map(raw => ({
            cashierId: raw.cashier_id || raw.cashierId || raw.id,
            cashierName: raw.cashier_name || raw.name,
            cashierEmail: raw.cashier_email || raw.email || '-',
            totalInvoicesCount:
              raw.total_invoices_count || raw.totalInvoices || 0,
            totalInvoicesAmount:
              raw.total_invoices_amount || raw.totalInvoicesAmount || 0,
            refundInvoicesAmount:
              raw.refund_invoices_amount || raw.refundInvoicesAmount || 0,
            pendingInvoicesCount:
              raw.pending_invoices_count || raw.pendingCount || 0,
            pendingInvoicesAmount:
              raw.pending_invoices_amount || raw.pendingInvoicesAmount || 0,
            approvedInvoicesCount:
              raw.approved_invoices_count || raw.approvedCount || 0,
            approvedInvoicesAmount:
              raw.approved_invoices_amount || raw.approvedInvoicesAmount || 0,
          }))

          // Pagination: support Laravel and meta styles
          if (
            this.all_data.current_page
            || this.all_data.per_page
            || this.all_data.total
          ) {
            this.historyPagination.page = this.all_data.current_page || 1
            this.historyPagination.pageSize = this.all_data.per_page || this.historyPagination.pageSize
            this.historyPagination.total = this.all_data.total || 0
          } else if (this.all_data.meta) {
            this.historyPagination.page = this.all_data.meta.page || 1
            this.historyPagination.pageSize = this.all_data.meta.take
              || this.all_data.meta.pageSize
              || this.historyPagination.pageSize
            this.historyPagination.total = this.all_data.meta.total || 0
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('common.error'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text:
              error.response?.data?.message
              || this.$t('cashiers.failed-fetch-cashiers'),
          },
        })
      } finally {
        this.historyLoading = false
      }
    },
    onHistoryPageSizeChange() {
      this.historyPagination.page = 1 // Reset to first page when changing page size
      this.fetchHistoryCashiers()
    },
    onHistoryPageChange() {
      this.fetchHistoryCashiers()
    },
    viewHistory(cashierId) {
      this.$router.push({
        name: 'cashier-history',
        params: { cashierId },
      })
    },
    // Shared methods
    formatDateForAPI(date) {
      if (!date) return null
      if (typeof date === 'string') return date
      const d = new Date(date)
      return d.toISOString().split('T')[0]
    },
    formatDateWithTime(date, isEndOfDay = false) {
      if (!date) return null
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')

      if (isEndOfDay) {
        // Last second of the day: 23:59:59
        return `${year}-${month}-${day} 23:59:59`
      }
      // First second of the day: 00:00:00 (midnight)
      return `${year}-${month}-${day} 00:00:00`
    },
    formatAmount(amount, currency = 'IQD') {
      if (!amount && amount !== 0) return '-'
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
      }).format(amount)
    },
    findTotalInvoicesAmount(item) {
      return this.formatAmount(item.totalInvoicesAmount - item.refundInvoicesAmount || 0)
    },
  },
}
</script>

<style scoped>
.text-nowrap {
  white-space: nowrap;
}
</style>
